import React from "react";

import {useInstrumentSelection} from "../InstrumentSelection/useInstrumentSelection";
import InstrumentSelectionDialog from "../InstrumentSelection/InstrumentSelectionDialog";


const BuyInstrumentModal = ({
  onClose,
  portfolio,
  transactions,
  instrumentsHandler,
  handleAddItems,
  predefinedFilter,
  customerId,
  isCustomerApp,
  isVirtual,
  portfolioInstruments,
}) => {
  const existingInstruments = React.useMemo(
    () => (transactions || []).map(i => i.data),
    [transactions]
  );

  const hook = useInstrumentSelection({
    existingInstruments,
    portfolioInstruments,
    instrumentsHandler,
    custodianId: portfolio.companyId,
    predefinedFilter,
    customerId,
    isCustomerApp,
    isVirtual,
    onSubmit: handleAddItems,
    onClose,
  });

  return (
    <InstrumentSelectionDialog
      hook={hook}
      instrumentsHandler={instrumentsHandler}
      portfolioInstruments={portfolioInstruments}
      predefinedFilter={predefinedFilter}
      customerId={customerId}
      isCustomerApp={isCustomerApp}
      isVirtual={isVirtual}
      onClose={onClose}
      dataId="add-instruments-modal"
    />
  );
};

export default BuyInstrumentModal;
